import {HandledError} from './handled-error'

type Props = {
  message: string
}

export class InvalidUrl extends HandledError {
  constructor({message}: Props) {
    super(message)
    this.name = 'InvalidUrl'
  }
}
